
// Get readable error message from geolocation error codes
export const getGeolocationErrorMessage = (error: GeolocationPositionError): string => {
  switch (error.code) {
    case 1:
      return "Accesso alla posizione negato. Concedi i permessi nelle impostazioni del browser.";
    case 2:
      return "Posizione non disponibile al momento. Verifica che il GPS sia attivo e riprova.";
    case 3:
      return "Timeout nel rilevamento della posizione. La rete potrebbe essere lenta o il GPS non ha un segnale chiaro.";
    default:
      return `Errore di geolocalizzazione: ${error.message}`;
  }
};

// Function to get a shorter version of the error message for UI display
export const getGeolocationErrorShort = (error: GeolocationPositionError): string => {
  switch (error.code) {
    case 1:
      return "Accesso negato";
    case 2:
      return "Posizione non disponibile";
    case 3:
      return "Timeout rilevamento";
    default:
      return "Errore geolocalizzazione";
  }
};

// Helper to determine if error is a permission issue
export const isPermissionError = (error: GeolocationPositionError): boolean => {
  return error.code === 1;
};

// Helper to determine if error is a timeout issue
export const isTimeoutError = (error: GeolocationPositionError): boolean => {
  return error.code === 3;
};
